

import { ChangeDetectionStrategy, Component, Inject, inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';


@Component({
  selector: 'app-dialog-document-viewer',
  imports: [CommonModule, MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatDialogTitle,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    MatIcon
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dialog-document-viewer.component.html',
  styleUrl: './dialog-document-viewer.component.css'
})
export class DialogDocumentViewerComponent {
  safeUrl: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { url: string, documentType:string },
    private sanitizer: DomSanitizer
  ) {
    // Sanitize the URL
    if(this.isImageUrl(data.documentType)){
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);}
    else{
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.url + "#toolbar=0");}
    }

  isImageUrl(documentType:string): boolean {
    if (documentType) {
      let urlString = documentType.toString();
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp'];
      return imageExtensions.some((ext) => urlString.toLowerCase().includes(ext));
    }
    else {
      return false;
    }
  }

}


